const productData = [
  {
    id: 1,
    name: "00 Pizza Flour - 2.2 lb.",
    brand: "DILVERBLOOM",
    category: "Baking",
    itemNumber: "GNF-148",
    price: "7.50",
    reviews: "2",
    rating: "5.0",
    image: "/img/dilverbloom-products/product-01.jpg",
    images: ["/img/dilverbloom-products/product-01.jpg"],
    size: ["One Size"],
    colors: ["Default"],
    material: "Soft Wheat Flour",
    description: [
      'Dilverbloom 00 Pizza Flour is a finely milled soft wheat flour selected for Neapolitan-style pizza at home. Its refined texture supports a smooth, elastic dough, steady fermentation, and a light, airy crust.',
      "Perfect for high-temperature ovens and home pizza baking alike, it creates pizzas with a crisp exterior, tender interior, and beautifully balanced chew. The 2.2 lb retail bag is ideal for home cooks, pizza enthusiasts, and anyone looking to elevate their dough with professional-quality Italian flour.",
      "Use it for traditional pizza dough, focaccia, breadsticks, and other artisan baked goods that benefit from a refined, high-performance flour.",
    ],
    Features: [
      'Authentic Italian "00" pizza flour',
      "Premium soft wheat blend",
      "Perfect for Neapolitan-style pizza",
      "Excellent fermentation properties",
      "2.2 lb (1kg) retail package",
    ],
  },
  {
    id: 2,
    name: "Italian 00 Pizza Flour - 2.2lb",
    brand: "DILVERBLOOM",
    category: "Baking",
    itemNumber: "GNF-123",
    price: "6.50",
    reviews: "10",
    rating: "5.0",
    image: "/img/dilverbloom-products/product-02.jpg",
    images: ["/img/dilverbloom-products/product-02.jpg"],
    size: ["One Size"],
    colors: ["Default"],
    material: "Soft Wheat Flour",
    description: [
      "Designed for home pizza making, this finely milled Italian-style 00 flour helps create supple dough with reliable stretch and a tender, crisp finish. It is also a versatile choice for fresh pasta, cakes, and breads.",
    ],
    Features: [
      'Finely milled Italian-style "00" flour',
      "Ideal for Neapolitan-style pizza",
      "Perfect for pasta, breads, and cakes",
      "Low gluten content for great stretch",
      "2.2 lb (1kg) package",
    ],
  },
  {
    id: 3,
    name: "00 Pasta Fresca Flour - 2.2 lb.",
    brand: "DILVERBLOOM",
    category: "Baking",
    itemNumber: "GNF-147",
    price: "7.50",
    reviews: "2",
    rating: "5.0",
    image: "/img/dilverbloom-products/product-03.jpg",
    images: ["/img/dilverbloom-products/product-03.jpg"],
    size: ["One Size"],
    colors: ["Default"],
    material: "Soft Wheat Flour",
    description: [
      "This finely milled soft wheat 00 flour is blended for fresh pasta dough with a smooth texture and dependable elasticity. It rolls easily into sheets and shapes while helping finished pasta hold sauces beautifully.",
    ],
    Features: [
      "Artisan Italian soft wheat flour",
      "Perfect for homemade pasta",
      "Specially formulated for pasta fresca",
      "Excellent texture and sauce absorption",
      "2.2 lb (1kg) package",
    ],
  },
  {
    id: 4,
    name: 'Soft Wheat Flour "Farina" 00 - 2.2lb',
    brand: "DILVERBLOOM",
    category: "Baking",
    itemNumber: "GNF-104",
    price: "5.00",
    reviews: "12",
    rating: "5.0",
    image: "/img/dilverbloom-products/product-04.jpg",
    images: ["/img/dilverbloom-products/product-04.jpg"],
    size: ["One Size"],
    colors: ["Default"],
    material: "Soft Wheat Flour",
    description: [
      'This super-fine soft wheat flour is a versatile pantry staple for bread, focaccia, pizza, cakes, and homemade pasta dough. Its delicate grind makes it easy to incorporate into everyday baking.',
    ],
    Features: [
      "Italian soft wheat flour type 00",
      "Perfect for bread, focaccia, and pizza",
      "Excellent for homemade pasta",
      "Super-soft texture",
      "2.2 lb (1kg) package",
    ],
  },
  {
    id: 5,
    name: "Verde 00 Pizza Flour - 22 lbs.",
    brand: "DILVERBLOOM",
    category: "Baking",
    itemNumber: "WBE-124",
    price: "30.00",
    originalPrice: "47.50",
    reviews: "3",
    rating: "5.0",
    image: "/img/dilverbloom-products/product-05.jpg",
    images: ["/img/dilverbloom-products/product-05.jpg"],
    size: ["One Size"],
    colors: ["Default"],
    material: "Soft Wheat Flour",
    description: [
      "Dilverbloom Verde 00 Pizza Flour is selected for traditional Neapolitan-style pizza and dependable high-temperature baking. The professional 22 lb format suits frequent home bakers, events, and food-service kitchens.",
      "Its balanced protein level supports hydration, fermentation, and dough elasticity for a thin base with a tender, airy rim. The dough remains easy to shape and can develop attractive light charring in a properly heated oven.",
    ],
    Features: [
      "Designed for Neapolitan-style pizza",
      "Premium quality Italian wheat",
      "High protein content",
      "Perfect for traditional pizza making",
      "22 lbs (10kg) package",
    ],
  },
  {
    id: 6,
    name: 'Semola Rimacinata "Durum Wheat Semolina" - 11 lbs. (5kg Bag)',
    brand: "DILVERBLOOM",
    category: "Baking",
    itemNumber: "GNF-150",
    price: "35.00",
    reviews: "4",
    rating: "5.0",
    image: "/img/dilverbloom-products/product-06.jpg",
    images: ["/img/dilverbloom-products/product-06.jpg"],
    size: ["One Size"],
    colors: ["Default"],
    material: "Durum Wheat Semolina",
    description: [
      "Semola rimacinata is a finely re-milled durum wheat semolina traditionally used for Italian pasta. Its naturally firm character helps pasta retain its shape after cooking, while the fine grind also works well for pizza crusts, breads, and other baked goods.",
    ],
    Features: [
      "Durum wheat semolina for traditional pasta",
      "High protein content for firm texture",
      "Fine grind for smooth texture",
      "Perfect for pizza crusts and bread",
      "11 lbs (5kg) package",
    ],
  },
  {
    id: 7,
    name: "Professional 00 Pizzeria Flour (Blue Bag) - 55 lbs.",
    brand: "DILVERBLOOM",
    category: "Baking",
    itemNumber: "WBE-127",
    price: "65.00",
    reviews: "1",
    rating: "5.0",
    image: "/img/dilverbloom-products/product-07.jpg",
    images: ["/img/dilverbloom-products/product-07.jpg"],
    size: ["One Size"],
    colors: ["Default"],
    material: "Soft Wheat Flour",
    description: [
      "This professional 00 pizzeria flour is blended for high-temperature ovens and consistent Italian-style pizza results. Its super-fine texture supports a light, airy crust with a crisp exterior.",
      "Balanced hydration and dough elasticity make it practical for repeated mixing, fermentation, and shaping. The 55 lb format is intended for high-volume kitchens and experienced pizza makers.",
    ],
    Features: [
      "Professional pizzeria quality flour",
      "Perfect for authentic Neapolitan pizza",
      "Super-fine texture and low gluten",
      "Special blend for high temperatures",
      "55 lbs package",
    ],
  },
  {
    id: 8,
    name: "Organic Sicilian Marzipan - 8.8oz",
    brand: "DILVERBLOOM",
    category: "Confections",
    itemNumber: "BKG-111",
    price: "13.00",
    reviews: "6",
    rating: "5.0",
    image: "/img/dilverbloom-products/product-08.jpg",
    images: ["/img/dilverbloom-products/product-08.jpg"],
    size: ["One Size"],
    colors: ["Default"],
    material: "Almonds and Sugar",
    description: [
      "Dilverbloom Organic Sicilian Marzipan combines almonds and sugar in a rich, pliable confection traditionally used for fruit-shaped sweets. It is also excellent for pastries, ice cream, cake decoration, or dipping in dark chocolate.",
    ],
    Features: [
      "Organic Sicilian marzipan",
      "Perfect for Frutta Martorana",
      "Great for pastries and ice creams",
      "Rich almond and sugar blend",
      "8.8oz package",
    ],
  },
  {
    id: 9,
    name: "All Purpose 00 Soft Wheat Flour - 2.2 lb",
    brand: "DILVERBLOOM",
    category: "Baking",
    itemNumber: "GNF-146",
    price: "6.00",
    reviews: "5",
    rating: "5.0",
    image: "/img/dilverbloom-products/product-09.jpg",
    images: ["/img/dilverbloom-products/product-09.jpg"],
    size: ["One Size"],
    colors: ["Default"],
    material: "Soft Wheat Flour",
    description: [
      "This finely milled all-purpose 00 soft wheat flour is selected for dependable everyday baking. Its versatile texture works across breads, pasta, pizza, pastries, and other kitchen staples.",
    ],
    Features: [
      "All-purpose soft wheat flour",
      "Perfect for breads, pasta, and pastries",
      "Dilverbloom pantry selection",
      "Versatile for all kitchen uses",
      "2.2 lb (1kg) package",
    ],
  },
  {
    id: 10,
    name: "Traditional Tarallini - 7.05 oz",
    brand: "DILVERBLOOM",
    category: "Snacks",
    itemNumber: "BBC-164",
    price: "6.00",
    reviews: "2",
    rating: "5.0",
    image: "/img/dilverbloom-products/product-10.jpg",
    images: ["/img/dilverbloom-products/product-10.jpg"],
    size: ["One Size"],
    colors: ["Default"],
    material: "Flour, Olive Oil, Wine",
    description: [
      "These little rings of crunchy perfection are made with flour, white wine, extra virgin olive oil, and a touch of salt. Their crisp texture and subtle, nutty olive oil flavor make them endlessly versatile, whether paired with cheese, charcuterie, or just a good glass of wine. Each bite is a nod to the Puglian tradition of honest, no-frills food that delivers big on flavor. Rustic yet refined, they're the kind of snack that quietly steals the show. Trust us, you'll want a second bag.",
    ],
    Features: [
      "Traditional Puglian tarallini",
      "Made with extra virgin olive oil",
      "Perfect with cheese and wine",
      "Crispy and versatile snack",
      "7.05 oz package",
    ],
  },
  {
    id: 11,
    name: "Onion Tarallini - 7.05 oz",
    brand: "DILVERBLOOM",
    category: "Snacks",
    itemNumber: "BBC-160",
    price: "6.00",
    reviews: "0",
    rating: "0.0",
    image: "/img/dilverbloom-products/product-11.jpg",
    images: ["/img/dilverbloom-products/product-11.jpg"],
    size: ["One Size"],
    colors: ["Default"],
    material: "Flour, Olive Oil, Onion",
    description: [
      "These golden, crunchy rings are infused with the deep, sweet sharpness of onion, balanced perfectly with the smooth richness of olive oil. They're not subtle—each bite hits hard with layers of flavor that linger on your palate. Ideal for tossing into a snack spread, pairing with wine, or just snacking straight from the bag, they're proof that simplicity can be damn good. Addictive in the best way possible, these tarallini are a bold, no-nonsense snack that's always up for a good time.",
    ],
    Features: [
      "Onion flavored tarallini",
      "Bold and addictive flavor",
      "Perfect with wine or charcuterie",
      "Crispy golden texture",
      "7.05 oz package",
    ],
  },
  {
    id: 12,
    name: "Waffle-Cut Potato Chips - 3.5 oz",
    brand: "DILVERBLOOM",
    category: "Snacks",
    itemNumber: "BBC-252",
    price: "4.50",
    reviews: "1",
    rating: "5.0",
    image: "/img/dilverbloom-products/product-12.jpg",
    images: ["/img/dilverbloom-products/product-12.jpg"],
    size: ["One Size"],
    colors: ["Default"],
    material: "Potatoes, Olive Oil",
    description: [
      "Meet a classic, elevated the Italian way.",
      "These waffle-cut potato chips pair a bold lattice texture with a satisfying crunch. Light seasoning lets the natural potato flavor come through in every bite.",
      "Made without artificial preservatives, colors, or flavors, these gluten-free chips contain no added MSG and are ready for snack boards, lunches, or casual aperitivo.",
    ],
    Features: [
      "Italian waffle-cut potato chips",
      "Premium thickness for extra crunch",
      "No artificial preservatives or colors",
      "Gluten free and no MSG",
      "3.5 oz package",
    ],
  },
  {
    id: 13,
    name: "Traditional Bruschette Crackers - 5.3 oz",
    brand: "DILVERBLOOM",
    category: "Crackers",
    itemNumber: "BBC-132",
    price: "5.00",
    reviews: "3",
    rating: "5.0",
    image: "/img/dilverbloom-products/product-13.jpg",
    images: ["/img/dilverbloom-products/product-13.jpg"],
    size: ["One Size"],
    colors: ["Default"],
    material: "Wheat, Olive Oil, Garlic",
    description: [
      "These traditional bruschette crackers are oven-baked, toasted with garlic, drizzled with extra virgin olive oil, and seasoned with salt and pepper. Serve them as part of an antipasti spread or alongside a casual dinner.",
    ],
    Features: [
      "Traditional Italian bruschette",
      "Oven-baked in Southern Italy",
      "Made with extra virgin olive oil",
      "Perfect for antipasti",
      "5.3 oz package",
    ],
  },
  {
    id: 14,
    name: "Grissini Semola di Grano du Duro (Semola Breadsticks) - 8.8 oz",
    brand: "DILVERBLOOM",
    category: "Breadsticks",
    itemNumber: "BBC-213",
    price: "8.00",
    reviews: "3",
    rating: "4.5",
    image: "/img/dilverbloom-products/product-14.jpg",
    images: ["/img/dilverbloom-products/product-14.jpg"],
    size: ["One Size"],
    colors: ["Default"],
    material: "Durum Wheat Semolina",
    description: [
      "These classic savory breadsticks are prepared with durum wheat semolina for a crisp, rustic bite. Enjoy them with vegetables, soups, cheeses, or antipasti; no preservatives are added.",
    ],
    Features: [
      "Traditional Italian breadsticks",
      "Made with durum wheat semolina",
      "No preservatives added",
      "Perfect with soups and vegetables",
      "8.8 oz package",
    ],
  },
  {
    id: 15,
    name: "Handmade Grissini Breadsticks - 7.05 oz",
    brand: "DILVERBLOOM",
    category: "Breadsticks",
    itemNumber: "BBC-208",
    price: "8.00",
    reviews: "2",
    rating: "4.5",
    image: "/img/dilverbloom-products/product-15.jpg",
    images: ["/img/dilverbloom-products/product-15.jpg"],
    size: ["One Size"],
    colors: ["Default"],
    material: "Wheat, Extra Virgin Olive Oil",
    description: [
      "Crunchy, handmade Grissini Breadsticks, crafted with extra virgin olive oil. Delightfully crunchy, grissini breadsticks are a fun addition to antipasti trays. We enjoy wrapping coppa or prosciutto around grissini for an easy appetizer!",
    ],
    Features: [
      "Handmade Italian breadsticks",
      "Made with extra virgin olive oil",
      "Perfect for antipasti",
      "Delightfully crunchy texture",
      "7.05 oz package",
    ],
  },
  {
    id: 16,
    name: "Cacio e Pepe Tarallini - 7.05 oz",
    brand: "DILVERBLOOM",
    category: "Snacks",
    itemNumber: "BBC-163",
    price: "6.00",
    reviews: "1",
    rating: "5.0",
    image: "/img/dilverbloom-products/product-16.jpg",
    images: ["/img/dilverbloom-products/product-16.jpg"],
    size: ["One Size"],
    colors: ["Default"],
    material: "Flour, Cheese, Black Pepper",
    description: [
      "Take the classic Roman pasta vibe and pack it into Puglia's iconic crunchy snack. These golden little rings are infused with the sharp tang of cheese and the bold kick of black pepper, delivering serious flavor with every bite. Perfectly crisp and just salty enough, they're the ultimate companion to your favorite aperitivo—think chilled prosecco or an ice-cold beer. Simple, rustic, and addictive, they're proof that Italy knows how to turn humble ingredients into something unforgettable. Pop open a bag, and don't expect to stop at one handful.",
    ],
    Features: [
      "Cacio e Pepe flavored tarallini",
      "Traditional Puglian snack",
      "Perfect with prosecco or beer",
      "Crispy and addictive",
      "7.05 oz package",
    ],
  },
  {
    id: 17,
    name: '"Fette Biscottate" Lagaccio Biscuits - 10.2oz',
    brand: "DILVERBLOOM",
    category: "Biscuits",
    itemNumber: "BBC-167",
    price: "9.75",
    reviews: "0",
    rating: "0.0",
    image: "/img/dilverbloom-products/product-17.jpg",
    images: ["/img/dilverbloom-products/product-17.jpg"],
    size: ["One Size"],
    colors: ["Default"],
    material: "Wheat, Sugar, Butter",
    description: [
      "These traditional Genovese-style biscuits are twice baked for a light, crisp texture that is especially enjoyable with coffee. Manitoba flour, natural white sourdough starter, and subtle barley malt notes give each slice a delicate, balanced flavor.",
    ],
    Features: [
      "Traditional Genovese biscuit",
      "Twice baked for crisp texture",
      "Made with natural sourdough",
      "Perfect with coffee",
      "10.2 oz package",
    ],
  },
  {
    id: 18,
    name: "Mini Baked Focaccia Bites with Sea Salt & Rosemary - 7 oz",
    brand: "DILVERBLOOM",
    category: "Snacks",
    itemNumber: "BBC-212",
    price: "5.00",
    reviews: "7",
    rating: "4.5",
    image: "/img/dilverbloom-products/product-18.jpg",
    images: ["/img/dilverbloom-products/product-18.jpg"],
    size: ["One Size"],
    colors: ["Default"],
    material: "Wheat, Extra Virgin Olive Oil, Rosemary, Sea Salt",
    description: [
      "Rosemary, sea salt, and olive oil give these mini baked focaccia bites a crisp, lightly toasted finish. Enjoy them on their own or pair them with dips, cheese, fruit preserves, and deli meats.",
    ],
    Features: [
      "Mini baked focaccia bites",
      "Made with rosemary and sea salt",
      "Extra virgin olive oil from southern Italy",
      "Perfect with dips and cheese",
      "7 oz package",
    ],
  },
  {
    id: 19,
    name: "White Chocolate Pistachio Truffles - 7 oz",
    brand: "DILVERBLOOM",
    category: "Chocolates",
    itemNumber: "CHC-334",
    price: "30.00",
    reviews: "1",
    rating: "5.0",
    image: "/img/dilverbloom-products/product-19.jpg",
    images: ["/img/dilverbloom-products/product-19.jpg"],
    size: ["One Size"],
    colors: ["Default"],
    material: "White Chocolate, Pistachios",
    description: [
      "These Piedmontese-style truffles pair sweet white chocolate with salted pistachios for a rich contrast of creamy and crunchy textures. Each piece offers a balanced, indulgent finish inspired by Italian confectionery traditions.",
    ],
    Features: [
      "Traditional Piedmontese truffles",
      "White chocolate with salted pistachios",
      "Luxurious flavor and texture",
      "Made in Turin, Italy",
      "7 oz package",
    ],
  },
  {
    id: 20,
    name: "Limoncello and Meringue Chocolate Truffles - 7 oz",
    brand: "DILVERBLOOM",
    category: "Chocolates",
    itemNumber: "CHC-343",
    price: "30.00",
    reviews: "1",
    rating: "5.0",
    image: "/img/dilverbloom-products/product-20.jpg",
    images: ["/img/dilverbloom-products/product-20.jpg"],
    size: ["One Size"],
    colors: ["Default"],
    material: "White Chocolate, Limoncello, Meringue",
    description: [
      "Bright limoncello flavor and delicate meringue meet a creamy white chocolate coating in these Italian-inspired truffles. The balance of citrus and sweetness makes them a refined after-dinner treat or thoughtful gift.",
    ],
    Features: [
      "Limoncello and meringue truffles",
      "Creamy white chocolate coating",
      "Perfect balance of tangy and sweet",
      "Made in Turin, Italy",
      "7 oz package",
    ],
  },
  {
    id: 21,
    name: "Original-Style Espresso Pods (Sicily) - 100 count",
    brand: "DILVERBLOOM",
    category: "Coffee",
    itemNumber: "WBE-123",
    price: "41.50",
    originalPrice: "41.50",
    reviews: "0",
    rating: "0.0",
    image: "/img/dilverbloom-products/product-21.jpg",
    images: ["/img/dilverbloom-products/product-21.jpg"],
    size: ["One Size"],
    colors: ["Default"],
    material: "Coffee Pods",
    description: [
      "Crafted in Sicily, these original-style espresso pods blend arabica and robusta beans for a balanced, full-flavored cup. Each capsule is designed to deliver a rich espresso with a smooth crema at home.",
      "Each box includes 100 pods, making it easy to enjoy authentic Italian espresso day after day.",
    ],
    Features: [
      "Compatible with common original-style capsule machines",
      "Premium arabica and robusta blend",
      "Crafted in Sicily, Italy",
      "100 count box",
      "Rich, bold flavor with crema",
    ],
  },
  {
    id: 22,
    name: "Whole Bean Espresso (Sicily) - 2.2lbs",
    brand: "DILVERBLOOM",
    category: "Coffee",
    itemNumber: "WBE-115",
    price: "43.50",
    originalPrice: "43.50",
    reviews: "12",
    rating: "5.0",
    image: "/img/dilverbloom-products/product-22.jpg",
    images: ["/img/dilverbloom-products/product-22.jpg"],
    size: ["One Size"],
    colors: ["Default"],
    material: "Whole Coffee Beans",
    description: [
      "This Sicilian-style whole bean espresso blends arabica and robusta beans for balanced body, aroma, and crema. Grind it fresh for espresso machines, moka pots, or your preferred brewing method.",
    ],
    Features: [
      "Premium whole bean espresso",
      "Arabica and robusta blend",
      "Traditional Sicilian production",
      "2.2lbs (1kg) bag",
      "Perfect for espresso machines",
    ],
  },
  {
    id: 23,
    name: "Espresso Hand Gesture Gift Box",
    brand: "DILVERBLOOM",
    category: "Gift Sets",
    itemNumber: "GBX-137",
    price: "70.00",
    originalPrice: "70.00",
    reviews: "0",
    rating: "0.0",
    image: "/img/dilverbloom-products/product-23.jpg",
    images: ["/img/dilverbloom-products/product-23.jpg"],
    size: ["One Size"],
    colors: ["Default"],
    material: "Coffee, Ceramic",
    description: [
      "This playful espresso gift set brings together Italian coffee tradition and illustrated hand gestures. It includes two espresso cups with saucers and a tin of freshly ground arabica and robusta coffee.",
      "The rich, velvety blend is protected by a freshness valve in a recyclable tin, making the set ready for gifting or for adding a little character to a daily espresso ritual.",
      "WHAT'S INSIDE:",
      "- Espresso Speaks Italian Ground Espresso Coffee - 8.8oz tin",
      "- 2 espresso cups with saucers",
    ],
    Features: [
      "Dilverbloom espresso gift set",
      "Two espresso cups and saucers",
      "Freshly ground Arabica and Robusta",
      "Iconic Italian hand gesture design",
      "Aroma-protective recyclable tin",
    ],
  },
];

export default productData;
